import Router, { useRouter } from "next/router";
import { COUNTRY_INT, DEFAULT_LANGUAGE, ICountry, ILanguage } from "src/constants/locale";

export const useRouterLocale = () => {
    const router = useRouter();

    return {
        country: (router.query.country as ICountry | undefined) ?? COUNTRY_INT,
        language: (router.query.language as ILanguage | undefined) ?? DEFAULT_LANGUAGE,
    };
};

/**
 * Non-reactive variant for event handlers and callbacks. Reads the next/router
 * singleton, so the calling component does not subscribe to (and re-render on)
 * router.query changes — e.g. the search page's shallow URL replaces.
 * Client-side only: the singleton has no query during SSR.
 */
export const getRouterLocale = () => ({
    country: (Router.query.country as ICountry | undefined) ?? COUNTRY_INT,
    language: (Router.query.language as ILanguage | undefined) ?? DEFAULT_LANGUAGE,
});
